<template>
  <div>
    <van-nav-bar
      class="backBox"
      title="历史预约"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="content_box">
      <div class="history_box">
        <van-pull-refresh
          v-model="refreshing"
          @refresh="onRefresh"
          success-text="刷新成功"
          :disabled="errorFlag"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text="没有更多了"
            :error.sync="error"
            error-text="请求失败，点击重新加载"
            @load="onLoad"
          >
            <div
              class="history_item"
              v-for="item in historyList"
              :key="item.id"
            >
              <div class="time">{{ item.set_useTime }}</div>
              <div class="floor">
                {{ item.set_address }}{{item.status | filterStatus}}
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'
import * as common from '../../api/common'

import * as utils from '../../api/utils'
import { Toast } from 'vant'
export default {
  data () {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      errorFlag: false,
      pageOption: {
        total: 0,
        page_no: 1,
        page_size: 15
      },
      historyList: []

    }
  },
  mounted () {
    this.queryList()
  },
  computed: {

  },
  filters: {
    filterStatus (item) {
      switch (item) {
        case 3:
          return ' (已取消)'
        case 4:
          return ' (已签到)'
        case 5:
          return ' (已签退)'
        case 16:
          return ' (超时取消)'
        case -11:
          return ' (已拒绝)'
        default:
          return ''
      }
    }
  },
  methods: {
    queryList () {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      const para = {
        page_no: this.pageOption.page_no,
        page_size: this.pageOption.page_size
      }
      api
        .axiosRequest(api.urlList.historyOrder, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            if (res.list.length === 0) {
              // this.historyList = []
              this.finished = true
              return false
            }
            res.list.forEach((item) => {
              let startTime = ''
              let endTime = ''

              startTime = utils.formatDate(item.begin_time)
              endTime = utils.formatDate(item.end_time)
              item.set_useTime = utils.formatTimeMDChinese(startTime) + ' ' + utils.formatTimeHourMinutes(startTime) + ' - ' + utils.formatTimeHourMinutes(endTime)
              item.set_address = item.type_name + ' ' + item.building_no + ' ' + item.name
            })

            this.pageOption.total = res.total
            this.historyList.push(...res.list)

            this.loading = false
            this.refreshing = false

            Toast.clear()
            if (this.historyList.length >= this.pageOption.total) {
              this.finished = true
            }
          } else {
            this.error = true
            this.errorFlag = true
            this.loading = false
            this.refreshing = false
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    onLoad () {
      // 监听到即执行
      console.log('滑到底了')

      //   再次调用 查询 下一页数据
      if (this.refreshing) {
        // 下拉刷新
        this.pageOption.page_no = 1
        this.queryList()
      } else {
        if (this.errorFlag) {
          // 说明上次加载失败 现在重新加载
          this.pageOption.page_no = 1
          this.errorFlag = false
          this.queryList()
          return false
        }
        // 触底加载
        if (this.historyList.length >= this.pageOption.total) {
          this.finished = true
        } else {
          this.pageOption.page_no = this.pageOption.page_no + 1
          this.queryList()
        }
      }
    },
    onRefresh () {
      this.historyList = []
      this.finished = false
      this.loading = true
      this.onLoad()
    },
    onClickLeft () {
      //   Toast('返回')
      this.$router.go(-1)
    }

  }
}
</script>
<style scoped lang="scss">
body {
  // height: 100%;
}
.content_box {
  width: 100%;
  height: 100%;
  .history_box {
    height: 100%;
    padding: 1rem 0;
    .history_item {
      padding: 1rem;
      background-color: #fafafa;
      margin-bottom: 1rem;
      .time {
        font-size: 18px;
        color: #333;
      }
      .floor {
        font-size: 14px;
        color: #666;
        margin-top: 0.5rem;
      }
    }
  }
}
</style>
